import React from 'react';
import PropTypes from 'prop-types';
import './SelectItem.scss';

const selectItem = (props) => {

	const { id, value, description, inputName, itemClicked } = props;

	return (
		<button
			onClick={itemClicked}
			data-id={id}
			data-description={description}
			data-value={value}
			data-name={inputName}
			className={'SelectItem'}
		>
			{
				description ||
                '-'
			}
		</button>
	);

};

selectItem.propTypes = {
	id: PropTypes.string,
	value: PropTypes.any,
	description: PropTypes.string,
	inputName: PropTypes.string,
	itemClicked: PropTypes.func,
};

export default selectItem;
